/**
 * @generated SignedSource<<75b5243233821580257773f60c09fec7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type McpInstallCallout_query$data = {
  readonly mcpCallout: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly type: string;
        readonly value: string;
      };
    }>;
  };
  readonly whoami: {
    readonly user: {
      readonly uuid: any;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"useMCPEnabled_query">;
  readonly " $fragmentType": "McpInstallCallout_query";
};
export type McpInstallCallout_query$key = {
  readonly " $data"?: McpInstallCallout_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"McpInstallCallout_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "McpInstallCallout_query",
  "selections": [
    {
      "alias": "mcpCallout",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "mcp_install_callout_dismissed"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"mcp_install_callout_dismissed\"}})"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uuid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMCPEnabled_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "55283d3fce46bff1fa2bd3c966462e59";

export default node;
